/**
 * Asynchronously loads the component for NotFoundPage
 */
import React, {lazy, Suspense} from 'react';
import LoadingView from 'components/LoadingView';
const Component = lazy(() => import('./index'));

const loadable = (props) =>
  <Suspense fallback={<LoadingView />}>
    <Component {...props} />
  </Suspense>;

export default loadable;
